<div *ngIf="dialogData.reservation as res">
  <div *ngIf="res[0] as firstCode">
    <div fxLayoutAlign="space-between start">
      <div fxLayout="column" fxLayoutGap="8px">
        <h2 fxLayoutGap="4px">
          <span>{{ firstCode.name }}</span>
          <span *ngIf="firstCode.reservation.advanced_status" class="text__xxsmall">
            ({{ firstCode.reservation.advanced_status }})
          </span>
        </h2>
        <span *ngIf="firstCode.properties?.length > 1">{{ firstCode.properties.length }} properties</span>
        <span *ngIf="firstCode.properties?.length === 1">{{ firstCode.properties[0].name }}</span>
      </div>
      <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
    </div>

    <div style="margin-top: 24px">
      <mat-form-field class="fw nopadding">
        <input matInput type="text" disabled [value]="firstCode.code" />
        <img
          class="clickable"
          matSuffix
          src="/assets/iconography/copy-grey.svg"
          alt="Copy"
          style="position: relative; top: -1px"
          matTooltip="Copy code"
          ngxClipboard
          [cbContent]="firstCode.code"
          (click)="codeCopied()" />
      </mat-form-field>
    </div>

    <div fxLayoutAlign="space-between center" style="margin-top: 12px">
      <div class="text__small" fxLayout fxLayoutGap="24px" fxLayout.lt-md="column" fxLayoutGap.lt-md="4px">
        <strong *ngIf="!firstCode.start && !firstCode.end">Always on</strong>
        <div *ngIf="firstCode.start" fxLayoutGap="4px">
          <label>Start:</label>
          <span>{{ firstCode.start | date: DATE_FORMAT }}</span>
        </div>

        <div *ngIf="firstCode.end" fxLayoutGap="4px">
          <label>End:</label>
          <span>{{ firstCode.end | date: DATE_FORMAT }}</span>
        </div>
      </div>

      <div fxLayoutAlign="start center" fxLayoutGap="8px">
        <label
          [class.grass-darker]="res | codeFirstUsedAt"
          [matTooltip]="
            (res | codeFirstUsedAt) ? 'Code first used at ' + (res | codeFirstUsedAt | date: DATE_FORMAT) : null
          ">
          {{ (res | codeFirstUsedAt) ? 'Code used' : 'Code not used' }}
        </label>
      </div>
    </div>
    <!-- edit and delete actions-->
    <div fxLayoutAlign="space-between center" fxLayoutGap="8px" class="actions-container">
      <sbnb-button
        size="mini"
        type="secondary"
        [disabled]="!(hasWritePermission$ | async) || !firstCode.actions.includes('edit')"
        [matTooltip]="
          !(hasWritePermission$ | async)
            ? 'You do not have permission to edit this code'
            : !firstCode.actions.includes('edit')
              ? 'This type of code cannot be edited'
              : ''
        "
        (clicked)="onEditCodeClicked()">
        Edit
      </sbnb-button>
      <sbnb-button
        size="mini"
        type="secondary"
        [disabled]="!(hasWritePermission$ | async) || !firstCode.actions.includes('delete')"
        [matTooltip]="
          !(hasWritePermission$ | async)
            ? 'You do not have permission to delete this code'
            : !firstCode.actions.includes('delete')
              ? 'This type of code cannot be deleted'
              : ''
        "
        [loading]="deleting"
        (clicked)="onDeleteClicked()">
        Delete
      </sbnb-button>
    </div>
  </div>

  <!-- For each code, display the lock name and timeline -->
  <div *ngFor="let code of res" class="lock-timeline-container">
    <div class="grass-darker strong text__small lock-timeline-title" fxLayoutAlign="start center" fxLayoutGap="8px">
      <div
        (click)="onLockClicked(code.device)"
        class="clickable lock-link"
        fxLayoutAlign="start center"
        fxLayoutGap="8px">
        <sbnb-icon
          *ngIf="code.device.device_type === 'lock'"
          icon="padlock"
          [size]="16"
          class="text-night-lighter"></sbnb-icon>
        <span>{{ code.device.name }}</span>
      </div>

      <div
        *ngIf="code.device.device_properties.online"
        fxFlex
        fxLayoutAlign="end center"
        fxLayoutGap="8px"
        [class.disabled]="code.device.computed?.changingLockStatus">
        <mat-spinner *ngIf="code.device.computed?.changingLockStatus" diameter="16"></mat-spinner>
        <span
          *ngIf="!code.device.computed?.changingLockStatus"
          [class.grass-darker]="code.device.device_properties.locked"
          [class.night]="!code.device.device_properties.locked"
          class="text__small strong">
          {{ code.device.device_properties.locked ? 'Locked' : 'Unlocked' }}
        </span>
        <mat-slide-toggle
          [disabled]="!(hasWritePermission$ | async)"
          [matTooltip]="!(hasWritePermission$ | async) ? 'You do not have permission to interact with locks' : null"
          [checked]="code.device.device_properties.locked"
          (change)="onDeviceLockToggled($event, code.device)"></mat-slide-toggle>
      </div>
    </div>

    <sbnb-timeline *ngIf="code.computed?.timeline" [timelines]="code.computed.timeline"></sbnb-timeline>
  </div>
</div>
